import type { BullsharkExpression } from '@suigar/suifrens-display-system';
import type { CapyExpression } from '@suigar/suifrens-display-system';

const positiveExpressionList = ['bigSmile', 'happy', 'heartEyes', 'kiss', 'laughing', 'relaxed', 'tongueOut', 'goofy'] as const;
const negativeExpressionList = ['cool', 'blush', 'angry', 'annoyed', 'crying', 'sad', 'sleepy', 'shocked', 'grimace', 'mischievous'] as const;

const sharedExpressionPool = [
	'angry',
	'annoyed',
	'bigSmile',
	'blush',
	'cool',
	'crying',
	'happy',
	'heartEyes',
	'kiss',
	'laughing',
	'mischievous',
	'relaxed',
	'sad',
	'shocked',
	'sleepy',
	'tongueOut',
	'wink',
	'dizzyFace',
	'goofy',
	'grimace',
] as const;

const capyExclusiveExpressions = ['showing', 'ourah'] as const;

type SharedExpression = (typeof sharedExpressionPool)[number];

const pickRandom = <T extends string>(list: readonly T[], exclude?: T): T => {
	const available = exclude ? list.filter((entry) => entry !== exclude) : [...list];
	if (available.length === 0) {
		return list[0];
	}
	return available[Math.floor(Math.random() * available.length)];
};

export const positiveExpressions = positiveExpressionList as unknown as CapyExpression[];
export const negativeExpressions = negativeExpressionList as unknown as CapyExpression[];

export const getRandomPositiveExpression = (): CapyExpression => {
	return pickRandom(positiveExpressions);
};

export const getRandomNegativeExpression = (): CapyExpression => {
	return pickRandom(negativeExpressions);
};

const bullsharkExpressionPool = sharedExpressionPool as unknown as BullsharkExpression[];
const capyExpressionPool = [...sharedExpressionPool, ...capyExclusiveExpressions] as unknown as CapyExpression[];

export const getRandomBullsharkExpression = (exclude?: BullsharkExpression): BullsharkExpression => {
	return pickRandom(bullsharkExpressionPool, exclude);
};

export const getRandomCapyExpression = (exclude?: CapyExpression): CapyExpression => {
	return pickRandom(capyExpressionPool, exclude);
};
